import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Card, FlexView, Button } from 'components/common'
import { TransportContext } from 'stores/ManagementTransportStore'
import styled from 'styled-components'
import moment from 'moment'

const Title = styled.div`
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
`

const SubTitle = styled.div`
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
`

const DeleteAttachModal = ({ isOpen, onOutsideClick, data }) => {
  const { manageAttachments } = useContext(TransportContext)
  const { t } = useTranslation()

  const deleteAttachment = async () => {
    const payload = {
      attachments_uuid: data.id,
      uri: data.url,
      option: 'delete'
    }
    await manageAttachments(payload, 'delete')
  }
  if (!data) {
    return null
  }

  return <Modal isOpen={isOpen} onOutsideClick={onOutsideClick}>
    <Card style={{ rowGap: "10px" }}>
      <Title>{t('transport.deleteAttach')}</Title>
      <SubTitle>{t('transport.areYouSureDeleteAttach')}</SubTitle>
      <text>{t('transport.name')}: {data.name}</text>
      <text>{t('transport.user')}: {data.usuario}</text>
      <text>{t('transport.dateAttach')}: {moment(data.data).format("DD/MM/YYYY hh:mm")}</text>
      <FlexView width="100%" flexDirection="row" alignItems="center" justifyContent="flex-end" style={{ columnGap: '5%' }}>
        <Button onClick={() => { onOutsideClick() }}>
          {t('transport.cancel')}
        </Button>
        <Button backgroundColor='primary' onClick={() => deleteAttachment()} color='white'>
          {t('transport.deleteAttach')}
        </Button>
      </FlexView>
    </Card>
  </Modal>
}

export default DeleteAttachModal
